import { IConfig } from "types";

export const hasFeature = (config: IConfig, feature: string) =>
  R.pathOr(false, ['settings', 'features', feature], config);

export const getConfigText = (config: IConfig, prop: string) =>
  R.pathOr(null, ['settings', 'text', prop], config);